import angular from "angular";

angular
    .module('ui-sentinel.shipments')
    .factory('TemplateEditorService', TemplateEditorService);

TemplateEditorService.$inject = ['ShipmentTemplatesService', 'SentinelUiSession', 'FeedbackService', 'SentryAccountApiService'];

function TemplateEditorService(ShipmentTemplatesService, SentinelUiSession, FeedbackService, SentryAccountApiService) {
    var emailValidator = /^([\w+-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i;
    var nextStopId = 0;
    var MIN_DURATION = 1;
    var MAX_DURATION = 45;
    var GEOFENCE_BEGIN_STRATEGIES = ['ArrivalGeofence', 'DepartureGeofence'];
    var GEOFENCE_END_OPTIONS = ['ArrivalGeofence', 'ArrivalMultipleOr', 'ArrivalMultipleAnd'];
    var MULTIPLE_CONDITION_END_OPTIONS = ['ArrivalMultipleOr', 'ArrivalMultipleAnd'];
    var BEGIN_STRATEGY_LABELS = {
        'date/time': 'Date/Time',
        'ArrivalGeofence': 'Arrival at Geofence',
        'DepartureGeofence': 'Departure from Geofence',
        'Immediately': 'Immediately'
    };
    var END_OPTION_LABELS = {
        'date/time': 'Date/Time',
        'ArrivalGeofence': 'Arrival at Geofence',
        'ArrivalMultipleOr': 'Multiple Conditions (Or)',
        'ArrivalMultipleAnd': 'Multiple Conditions (And)'
    };

    var service = {
        template: null,
        availableGeofences: [],
        shipmentDevice: null,
        feedback: FeedbackService,
        name: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank || this.errors.isDuplicate;
            },
            errors: {
                isBlank: true,
                isDuplicate: false
            },
            validate: validateName
        },
        duration: {
            min: MIN_DURATION,
            max: MAX_DURATION,
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isOutOfRange;
            },
            errors: {
                isOutOfRange: false
            },
            validate: validateDuration
        },
        beginTrackingStrategyType: {
            value: null,
            isPristine: true,
            hasError: function () {
                return false;
            },
            errors: {},
            validate: function () {
            }
        },
        beginTrackingGeofence: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank;
            },
            errors: {
                isBlank: false
            },
            validate: validateBeginTrackingGeofence
        },
        endTrackingOption: {
            value: null,
            isPristine: true,
            hasError: function () {
                return false;
            },
            errors: {},
            validate: function () {
            }
        },
        endTrackingGeofence: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank || this.errors.thisOrLight;
            },
            errors: {
                isBlank: false,
                thisOrLight: false
            },
            validate: validateEndTrackingGeofence
        },
        arrivalLightLevel: {
            value: null,
            min: 0,
            max: 100,
            hasError: function () {
                return this.errors.isBlank || this.errors.belowMin || this.errors.aboveMax || this.errors.thisOrGeofence;
            },
            errors: {
                isBlank: false,
                belowMin: false,
                aboveMax: false,
                thisOrGeofence: false
            },
            validate: validateArrivalLightLevel
        },
        arrivalLightLevelThrottleHours: {
            value: null,
            min: 0,
            max: 48,
            hasError: function () {
                return this.errors.belowMin || this.errors.aboveMax;
            },
            errors: {
                belowMin: false,
                aboveMax: false
            },
            validate: validateArrivalLightLevelThrottleHours
        },
        completionDelay: {
            value: null,
            min: 1,
            max: 240,
            hasError: function () {
                return this.errors.belowMin || this.errors.aboveMax;
            },
            errors: {
                belowMin: false,
                aboveMax: false
            },
            validate: validateCompletionDelay
        },
        device: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.value === null;
            },
            errors: {
                isBlank: true,
                isNotFound: false
            },
            validate: validateDevice
        },
        sentinels: [],
        subscribers: [],
        shipmentEmails: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.invalidEmails.length > 0;
            },
            errors: {
                invalidEmails: []
            },
            validate: validateSubscribers
        },
        stops: {
            origin: newEditorStop('blank'),
            other: [],
            destination: newEditorStop('blank'),
            hasError: stopsHaveError
        },
        isValid: false,
        addStop: addStop,
        removeStop: removeStop,
        save: save,
        createStops: createStops,
        stopToSave: stopToSave,
        edit: edit,
        create: create,
        reset: reset,
        clear: clear,
        //validate: validate,
        validateStops: validateStops,
        validateTrackingStrategies: validateTrackingStrategies,
        hasTrackingStrategyError: hasTrackingStrategyError,
        isGeofenceBeginStrategy: isGeofenceBeginStrategy,
        isGeofenceEndOption: isGeofenceEndOption,
        isMultipleConditionEndOption: isMultipleConditionEndOption,
        canReverseGeofences: canReverseGeofences,
        resolveTrackingStrategy: resolveTrackingStrategy,
        setTrackingStrategyFromShipmentEditor: setTrackingStrategyFromShipmentEditor,
        beginTrackingStrategyLabel: beginTrackingStrategyLabel,
        endTrackingStrategyLabel: endTrackingStrategyLabel,
        stopFromShipmentStop: stopFromShipmentStop
    };

    return service;

    function addStop(type) {
        var stop = newEditorStop(type === null ? 'blank' : type);
        stop.stopId = nextStopId++;
        service.stops.other.push(stop);
        return stop;
    }

    function clear() {
        service.template = null;
        service.availableGeofences = [];
        nextStopId = 0;
        init();
    }

    function create(availableGeofences) {
        service.template = null;
        service.availableGeofences = availableGeofences;
        loadDevice();
        reset();
    }

    function edit(template, availableGeofences) {
        console.log("Template", template);
        service.template = template;
        service.availableGeofences = availableGeofences;
        loadDevice();
        reset();
    }

    function loadDevice() {
        console.log("loadDevices", service.template);
        if (!service.template || !service.template.deviceTagId)
            return;
        var promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, service.template.deviceTagId).$promise;

        promise.then(
            function (result) {
                console.log(result);
                service.shipmentDevice = result[0];
                service.device.value = result[0];
            },
            function (error) {
                console.log(error);
                service.feedback.addErrorFromError(error);
            }
        );
    }

    function validateDevice() {
        service.device.isPristine = false;
        service.device.errors.isNotFound = false;
        service.device.errors.isBlank = service.device.value === null;
        if (service.device.errors.isBlank) {
            return;
        }

        var promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, service.device.value.imei).$promise;
        promise.then(
            function (result) {
                //we expect this
            },
            function (error) {
                service.device.errors.isNotFound = true;
            }
        );
    }

    function newEditorStop(type) {
        return {
            type: type,
            address: {
                value: null,
                isPristine: true,
                isChanging: false,
                hasError: function () {
                    return this.errors.isBlank;
                },
                errors: {
                    isBlank: true
                },
                validate: function () {
                    this.isPristine = false;
                    this.errors.isBlank = !this.value;
                }
            },
            geofence: {
                name: null,
                value: null,
                isPristine: true,
                isChanging: false,
                hasError: function () {
                    return this.errors.isBlank;
                },
                errors: {
                    isBlank: true
                },
                validate: function () {
                    this.isPristine = false;
                    this.errors.isBlank = !this.value;
                }
            },
            locationSearch: {
                value: null,
                location: null,
                availableLocations: [],
                isPristine: true,
                hasError: function () {
                    return this.errors.isBlank || this.errors.hasZeroResults || this.errors.isLocationMissing;
                },
                errors: {
                    isBlank: true,
                    isLocationMissing: false,
                    hasZeroResults: false
                },
                validate: function () {
                    this.isPristine = false;
                    this.errors.isBlank = !this.value;
                    this.errors.isLocationMissing = false;
                    this.errors.hasZeroResults = false;

                    if (!this.errors.isBlank) {
                        this.errors.isLocationMissing = !this.location;
                    }
                }
            },
            validate: function () {
                validateStop(this);
            },
            hasError: function () {
                return (this.type === 'address' && this.address.hasError()) || (this.type === 'geofence' && this.geofence.hasError());
            }
        };
    }

    function editorStop(templateStop) {
        /*var stop = newEditorStop('blank');

        if (templateStop.geofenceId) {
            stop.type = 'geofence';
            stop.geofence.value = _.find(service.availableGeofences, { geofenceId: templateStop.geofenceId });
            stop.geofence.name = stop.geofence.value.name;
        }
        else {
            stop.type = 'address';
            stop.address.value = templateStop.address;
            stop.locationSearch.value = templateStop.address;
        }
        return stop;*/

        var stop = newEditorStop('blank');

        if (templateStop.address === templateStop.nameForAddress) {
            stop.type = 'address';
            stop.address.value = templateStop.address;
            stop.locationSearch.value = templateStop.address;
        } else {
            stop.type = 'geofence';
            stop.geofence.name = templateStop.nameForAddress;
            stop.geofence.value = _.find(service.availableGeofences, { name: templateStop.nameForAddress });
        }
        stop.destinationId = templateStop.destinationId;

        return stop;
    }

    function init() {
        service.name.value = null;
        service.name.isPristine = true;
        service.name.errors.isBlank = true;
        service.name.isDuplicate = false;
        service.duration.value = null;
        service.duration.isPristine = true;
        service.duration.errors.isOutOfRange = false;
        service.beginTrackingStrategyType.value = null;
        service.beginTrackingStrategyType.isPristine = true;
        service.beginTrackingGeofence.value = null;
        service.beginTrackingGeofence.isPristine = true;
        service.beginTrackingGeofence.errors.isBlank = false;
        service.endTrackingOption.value = null;
        service.endTrackingOption.isPristine = true;
        service.endTrackingGeofence.value = null;
        service.endTrackingGeofence.isPristine = true;
        service.endTrackingGeofence.errors.isBlank = false;
        service.endTrackingGeofence.errors.thisOrLight = false;
        service.arrivalLightLevel.value = null;
        service.arrivalLightLevel.errors.isBlank = false;
        service.arrivalLightLevel.errors.thisOrGeofence = false;
        service.arrivalLightLevel.errors.belowMin = false;
        service.arrivalLightLevel.errors.aboveMax = false;
        service.arrivalLightLevelThrottleHours.value = null;
        service.arrivalLightLevelThrottleHours.errors.belowMin = false;
        service.arrivalLightLevelThrottleHours.errors.aboveMax = false;
        service.completionDelay.value = null;
        service.completionDelay.errors.belowMin = false;
        service.completionDelay.errors.aboveMax = false;
        service.subscribers = [];
        service.shipmentEmails.value = null;
        service.shipmentEmails.isPristine = true;
        service.shipmentEmails.errors.invalidEmails = [];
        service.stops.origin = newEditorStop('blank');
        service.stops.other = [];
        service.stops.destination = newEditorStop('blank');
        service.device.value = null;
        service.device.isPristine = true;
        service.device.errors.isBlank = true;
        service.device.errors.isNotFound = false;
        service.sentinels = [];
    }

    function reset() {
        init();

        if (service.template === null) {
            return;
        }

        service.name.value = service.template.name;
        // the api omits the duration when the template has none, so it arrives as undefined
        service.duration.value = service.template.defaultTrackingTimeSpanInDays >= MIN_DURATION ?
            service.template.defaultTrackingTimeSpanInDays : null;
        service.beginTrackingStrategyType.value = service.template.beginTrackingStrategyType || null;
        service.beginTrackingGeofence.value = findGeofence(
            service.beginTrackingStrategyType.value === 'ArrivalGeofence' ?
                service.template.beginTrackingArrivalGeofenceId :
                service.template.beginTrackingDepartureGeofenceId);
        service.endTrackingOption.value = toEndTrackingOption(service.template.endTrackingStrategyType, service.template.endTrackingRequireAllConditions);
        service.endTrackingGeofence.value = findGeofence(service.template.endTrackingArrivalGeofenceId);
        if (isMultipleConditionEndOption(service.endTrackingOption.value)) {
            var events = service.template.endTrackingArrivalEvents || [];
            var lightEvent = _.find(events, { propertyName: 'LightValue', operator: '>' });
            var throttleEvent = _.find(events, { propertyName: 'ShipmentAgeHours', operator: '>=' });
            service.arrivalLightLevel.value = lightEvent ? lightEvent.value : null;
            service.arrivalLightLevelThrottleHours.value = throttleEvent ? throttleEvent.value : null;
            service.completionDelay.value = service.template.endTrackingArrivalTimeDelayMinutes || null;
        }
        service.subscribers = service.template.subscribers !== null ? service.template.subscribers : [];
        service.shipmentEmails.value = service.template.shipmentEmails !== null ? joinEmails(service.template.shipmentEmails) : null;
        service.device.value = null;
        service.device.isPristine = true;
        service.device.errors.isBlank = true;
        service.device.errors.isNotFound = false;
        service.sentinels = [];
        service.sentinels = service.template.sentinels;

        _.forEach(service.template.stops, function (templateStop) {
            /*if (templateStop.stopType.toLowerCase() === 'origin') {
                service.stops.origin = editorStop(templateStop);
                return;
            }
            if (templateStop.stopType.toLowerCase() === 'destination') {
                    service.stops.destination = editorStop(templateStop);
                return;
            }*/

            var otherStop = editorStop(templateStop);
            otherStop.stopId = nextStopId++;
            service.stops.other.push(otherStop);
        });
    }

    function joinEmails(emailsArray) {
        console.log("joinEmails", emailsArray);
        if (emailsArray.length == 0)
            return "";
        var emails = "";
        emailsArray.forEach(item => emails += item.email + ",");
        console.log("emaiils", emails);
        return emails.substring(0, emails.length - 1);
    }

    function buildArrayEmails(emailsArraySource) {
        if (!emailsArraySource)
            return [];
        var emails = [];
        emailsArraySource.forEach(item => emails.push({ "email": item }));
        return emails;
    }

    function removeStop(stopId) {
        var stops = [];
        _.forEach(service.stops.other, function (stop) {
            if (stop.stopId !== stopId) {
                stops.push(stop);
            }
        });
        service.stops.other = stops;
    }

    function createStops(template, prebuiltStops) {
        var stops = [];
        if (prebuiltStops) {
            stops = prebuiltStops;
        } else {
            _.forEach(service.stops.other, function (stop) {
                stops.push(stopToSave('Stop', stop));
            });
        }

        if (stops.length == 0)
            return null;

        console.log("Stops", stops);

        return ShipmentTemplatesService.addStops(SentinelUiSession.focus, template.id, stops).$promise;
    }

    function save() {
        service.feedback.clear();
        validateName();
        validateDuration();
        validateStops();
        validateSubscribers();
        validateDevice();
        validateTrackingStrategies();

        if (service.name.hasError() || service.duration.hasError() || service.stops.hasError() || service.shipmentEmails.hasError() ||
            hasTrackingStrategyError()) {
            return null;
        }

        var templateToSave = {
            name: service.name.value,
            defaultTrackingTimeSpanInDays: service.duration.value,
            subscribers: service.subscribers, // ? service.subscribers.value.replace(/\s/g,'').split(";").join(",").split(',') : null,
            shipmentEmails: service.shipmentEmails.value ? buildArrayEmails(service.shipmentEmails.value.replace(/\s/g, '').split(";").join(",").split(',')) : [],
            // deviceTagId: service.device.value.imei,
            sentinels: [],
            stops: []
        };
        /*if (service.stops.origin.type !== 'blank') {
            templateToSave.stops.push(stopToSave('Origin', service.stops.origin));
        }
        _.forEach(service.stops.other, function (stop) {
            templateToSave.stops.push(stopToSave('Stop', stop));
        });
        if (service.stops.destination.type !== 'blank') {
            templateToSave.stops.push(stopToSave('Destination', service.stops.destination));
        }*/

        _.forEach(service.sentinels, function (s) {
            templateToSave.sentinels.push({
                "sentinelId": s.sentinelId,
                "deviceId": s.deviceId
            });
        });

        applyTrackingStrategiesToTemplate(templateToSave);

        if (service.template === null) {
            templateToSave.id = null;
            templateToSave.clientGuid = SentinelUiSession.focus.id;
        } else {
            templateToSave.id = service.template.id;
            templateToSave.clientGuid = service.template.clientGuid;
        }

        return service.template === null ?
            ShipmentTemplatesService.createTemplate(SentinelUiSession.focus, templateToSave).$promise :
            ShipmentTemplatesService.updateTemplate(templateToSave).$promise;
    }

    function stopsHaveError() {

        var otherError = false;
        _.forEach(service.stops.other, function (stop) {
            stop.validate();
            otherError = stop.hasError() || otherError;
        });
        return /*service.stops.origin.hasError() || service.stops.destination.hasError() ||*/ otherError;
    }

    function stopToSave(stopType, editorStop) {
        var shipmentStop = {
            destinationId: 0,
            nameForAddress: null,
            address: null,
            addressLongitude: null,
            addressLatitude: null,
            shipmentStopPolygonGeofence: null,
            shipmentStopRadialGeofence: null,
            hasArrived: false
        };
        if (editorStop.type === 'address') {
            var location = editorStop.locationSearch.location;
            var longitude = location ? location.geometry.location.lng() : editorStop.addressLongitude;
            var latitude = location ? location.geometry.location.lat() : editorStop.addressLatitude;
            shipmentStop.nameForAddress = editorStop.address.value;
            shipmentStop.address = editorStop.address.value;
            shipmentStop.addressLongitude = longitude;
            shipmentStop.addressLatitude = latitude;
            shipmentStop.shipmentStopRadialGeofence = {
                longitudeCenter: longitude,
                latitudeCenter: latitude,
                radiusUnitType: 'miles',
                radius: 2.0
            };
        } else {
            shipmentStop.nameForAddress = editorStop.geofence.value.name;
            shipmentStop.address = editorStop.geofence.value.address;

            if (editorStop.geofence.value.type === 'polygon') {
                var coords = editorStop.geofence.value.shapeText.replace('POLYGON ((', '').replace('))', '').split(', ');
                var latLngBounds = new google.maps.LatLngBounds();
                _.forEach(coords, function (coord) {
                    var point = coord.split(' ');
                    var latLng = new google.maps.LatLng(Number(point[1]), Number(point[0]));
                    latLngBounds.extend(latLng);
                });
                var center = latLngBounds.getCenter();

                shipmentStop.addressLongitude = center.lng();
                shipmentStop.addressLatitude = center.lat();
                shipmentStop.shipmentStopPolygonGeofence = {
                    shapeText: editorStop.geofence.value.shapeText
                };
            } else {
                shipmentStop.addressLongitude = editorStop.geofence.value.longitudeCenter;
                shipmentStop.addressLatitude = editorStop.geofence.value.latitudeCenter;
                shipmentStop.shipmentStopRadialGeofence = {
                    longitudeCenter: editorStop.geofence.value.longitudeCenter,
                    latitudeCenter: editorStop.geofence.value.latitudeCenter,
                    radiusUnitType: editorStop.geofence.value.radiusUnitType,
                    radius: editorStop.geofence.value.radius
                };
            }
        }

        if (editorStop.destinationId) {
            shipmentStop.destinationId = editorStop.destinationId;
        }

        return shipmentStop;
        /*return {
            stopType: stopType,
            geofenceId: editorStop.type === 'geofence' ? editorStop.geofence.value.id : null,
            name: editorStop.type === 'geofence' ? editorStop.geofence.value.name : editorStop.address.value,
            address: editorStop.type === 'address' ? editorStop.address.value : null,
            useNameFromGeofence: editorStop.type === 'geofence',
            useAddressFromGeofence: editorStop.type === 'geofence',
            contactName: null,
            contactPhone: null
        };*/
    }

    // function validate() {
    //     service.isValid = true;
    //     validateName();
    //     validateDuration();
    //     validateStops();
    //     validateSubscribers();
    //
    //     service.isValid = !(service.name.hasError() ||
    //         service.duration.hasError() ||
    //         service.stops.hasError() ||
    //         service.subscribers.hasError());
    //
    // }

    function isGeofenceBeginStrategy(strategyType) {
        return GEOFENCE_BEGIN_STRATEGIES.indexOf(strategyType) >= 0;
    }

    function isGeofenceEndOption(endTrackingOption) {
        return GEOFENCE_END_OPTIONS.indexOf(endTrackingOption) >= 0;
    }

    function isMultipleConditionEndOption(endTrackingOption) {
        return MULTIPLE_CONDITION_END_OPTIONS.indexOf(endTrackingOption) >= 0;
    }

    function beginTrackingStrategyLabel(strategyType) {
        return BEGIN_STRATEGY_LABELS[strategyType] || '';
    }

    function endTrackingStrategyLabel(strategyType, requireAllConditions) {
        return END_OPTION_LABELS[toEndTrackingOption(strategyType, requireAllConditions)] || '';
    }

    // the API stores ArrivalMultiple + a require-all flag; the UI presents them as two options
    function toEndTrackingOption(strategyType, requireAllConditions) {
        if (!strategyType) {
            return null;
        }
        if (strategyType === 'ArrivalMultiple') {
            return requireAllConditions ? 'ArrivalMultipleAnd' : 'ArrivalMultipleOr';
        }
        return strategyType;
    }

    function findGeofence(geofenceId) {
        if (!geofenceId) {
            return null;
        }
        return _.find(service.availableGeofences, { id: geofenceId }) || null;
    }

    // a template with a geofence at both ends of tracking can have those geofences swapped
    // when a shipment is created from it (the return trip)
    function canReverseGeofences() {
        return isGeofenceBeginStrategy(service.beginTrackingStrategyType.value) &&
            !!service.beginTrackingGeofence.value &&
            isGeofenceEndOption(service.endTrackingOption.value) &&
            !!service.endTrackingGeofence.value;
    }

    // returns the strategy types and geofences to apply to a shipment editor, optionally with
    // the begin and end geofences swapped
    function resolveTrackingStrategy(reverseGeofences) {
        var swap = reverseGeofences && canReverseGeofences();
        var isMultiple = isMultipleConditionEndOption(service.endTrackingOption.value);
        return {
            beginTrackingStrategyType: service.beginTrackingStrategyType.value,
            beginGeofence: swap ? service.endTrackingGeofence.value : service.beginTrackingGeofence.value,
            endTrackingOption: service.endTrackingOption.value,
            endGeofence: swap ? service.beginTrackingGeofence.value : service.endTrackingGeofence.value,
            arrivalLightLevel: isMultiple ? service.arrivalLightLevel.value : null,
            arrivalLightLevelThrottleHours: isMultiple ? service.arrivalLightLevelThrottleHours.value : null,
            completionDelay: isMultiple ? service.completionDelay.value : null
        };
    }

    // copies the tracking strategies from a ShipmentEditorService instance. Options:
    //   includeBegin / includeEnd - whether each strategy (and its geofence) is copied; a strategy that
    //                               is not included is cleared on the template (default: both included)
    //   reverseGeofences          - the shipment editor holds geofences that were reversed from this
    //                               template, so they are swapped back (default: false)
    function setTrackingStrategyFromShipmentEditor(shipmentEditor, options) {
        var settings = _.assign({ includeBegin: true, includeEnd: true, reverseGeofences: false }, options);
        var beginStrategy = shipmentEditor.beginTrackingStrategyType.value || null;
        var endOption = shipmentEditor.endTrackingOption.value || null;
        var beginGeofence = null;
        if (beginStrategy === 'ArrivalGeofence') {
            beginGeofence = shipmentEditor.endGeofence.value || null;
        } else if (beginStrategy === 'DepartureGeofence') {
            beginGeofence = shipmentEditor.beginGeofence.value || null;
        }
        var endGeofence = isGeofenceEndOption(endOption) ? (shipmentEditor.endGeofence2.value || null) : null;
        var isMultiple = settings.includeEnd && isMultipleConditionEndOption(endOption);

        var swap = settings.reverseGeofences && isGeofenceBeginStrategy(beginStrategy) && beginGeofence && isGeofenceEndOption(endOption) && endGeofence;

        service.beginTrackingStrategyType.value = settings.includeBegin ? beginStrategy : null;
        service.beginTrackingGeofence.value = settings.includeBegin ? (swap ? endGeofence : beginGeofence) : null;
        service.endTrackingOption.value = settings.includeEnd ? endOption : null;
        service.endTrackingGeofence.value = settings.includeEnd ? (swap ? beginGeofence : endGeofence) : null;
        service.arrivalLightLevel.value = isMultiple ? valueOrNull(shipmentEditor.arrivalLightLevel.value) : null;
        service.arrivalLightLevelThrottleHours.value = isMultiple ? valueOrNull(shipmentEditor.arrivalLightLevelThrottleHours.value) : null;
        service.completionDelay.value = isMultiple ? valueOrNull(shipmentEditor.completionDelay.value) : null;
    }

    function valueOrNull(value) {
        return value === undefined || value === '' ? null : value;
    }

    function applyTrackingStrategiesToTemplate(templateToSave) {
        var beginStrategy = service.beginTrackingStrategyType.value || null;
        var beginGeofence = service.beginTrackingGeofence.value;
        templateToSave.beginTrackingStrategyType = beginStrategy;
        templateToSave.beginTrackingArrivalGeofenceId = beginStrategy === 'ArrivalGeofence' && beginGeofence ? beginGeofence.id : null;
        templateToSave.beginTrackingDepartureGeofenceId = beginStrategy === 'DepartureGeofence' && beginGeofence ? beginGeofence.id : null;

        var endOption = service.endTrackingOption.value || null;
        var endGeofence = service.endTrackingGeofence.value;
        switch (endOption) {
            case 'ArrivalMultipleOr':
                templateToSave.endTrackingStrategyType = 'ArrivalMultiple';
                templateToSave.endTrackingRequireAllConditions = false;
                break;
            case 'ArrivalMultipleAnd':
                templateToSave.endTrackingStrategyType = 'ArrivalMultiple';
                templateToSave.endTrackingRequireAllConditions = true;
                break;
            default:
                templateToSave.endTrackingStrategyType = endOption;
                templateToSave.endTrackingRequireAllConditions = endOption ? false : null;
                break;
        }
        templateToSave.endTrackingArrivalGeofenceId = isGeofenceEndOption(endOption) && endGeofence ? endGeofence.id : null;

        // the multiple condition options carry the same arrival events and delay as a shipment does
        templateToSave.endTrackingArrivalEvents = null;
        templateToSave.endTrackingArrivalTimeDelayMinutes = null;
        if (isMultipleConditionEndOption(endOption)) {
            if (service.arrivalLightLevel.value !== null) {
                templateToSave.endTrackingArrivalEvents = [
                    {
                        propertyName: 'LightValue',
                        operator: '>',
                        value: service.arrivalLightLevel.value
                    },
                    {
                        propertyName: 'ShipmentAgeHours',
                        operator: '>=',
                        value: service.arrivalLightLevelThrottleHours.value !== null ? service.arrivalLightLevelThrottleHours.value : 0
                    }
                ];
            }
            if (service.completionDelay.value !== null) {
                templateToSave.endTrackingArrivalTimeDelayMinutes = service.completionDelay.value;
            }
        }
    }

    // builds a template stop from a stop of an existing shipment (already in the API shape)
    function stopFromShipmentStop(shipmentStop) {
        return {
            destinationId: 0,
            nameForAddress: shipmentStop.nameForAddress,
            address: shipmentStop.address,
            addressLongitude: shipmentStop.addressLongitude,
            addressLatitude: shipmentStop.addressLatitude,
            shipmentStopPolygonGeofence: shipmentStop.shipmentStopPolygonGeofence ? {
                shapeText: shipmentStop.shipmentStopPolygonGeofence.shapeText
            } : null,
            shipmentStopRadialGeofence: shipmentStop.shipmentStopRadialGeofence ? {
                longitudeCenter: shipmentStop.shipmentStopRadialGeofence.longitudeCenter,
                latitudeCenter: shipmentStop.shipmentStopRadialGeofence.latitudeCenter,
                radiusUnitType: shipmentStop.shipmentStopRadialGeofence.radiusUnitType,
                radius: shipmentStop.shipmentStopRadialGeofence.radius
            } : null,
            hasArrived: false
        };
    }

    function validateBeginTrackingGeofence() {
        service.beginTrackingGeofence.isPristine = false;
        service.beginTrackingGeofence.errors.isBlank =
            isGeofenceBeginStrategy(service.beginTrackingStrategyType.value) && !service.beginTrackingGeofence.value;
    }

    // these rules mirror the shipment editor: the Or option needs either the geofence or the light
    // level, every other geofence option needs the geofence
    function validateEndTrackingGeofence() {
        service.endTrackingGeofence.isPristine = false;
        if (service.endTrackingOption.value === 'ArrivalMultipleOr') {
            service.endTrackingGeofence.errors.isBlank = false;
            var bothMissing = !service.endTrackingGeofence.value && isBlankValue(service.arrivalLightLevel.value);
            service.endTrackingGeofence.errors.thisOrLight = bothMissing;
            service.arrivalLightLevel.errors.thisOrGeofence = bothMissing;
            return;
        }
        service.endTrackingGeofence.errors.thisOrLight = false;
        service.arrivalLightLevel.errors.thisOrGeofence = false;
        service.endTrackingGeofence.errors.isBlank =
            isGeofenceEndOption(service.endTrackingOption.value) && !service.endTrackingGeofence.value;
    }

    // a template with the And end strategy must carry a light level (the Or strategy is covered by the
    // geofence check); the throttle hours and completion delay are optional but must be in range when given
    function validateArrivalLightLevel() {
        var field = service.arrivalLightLevel;
        field.errors.isBlank = false;
        field.errors.belowMin = false;
        field.errors.aboveMax = false;
        if (!isMultipleConditionEndOption(service.endTrackingOption.value)) {
            return;
        }
        if (service.endTrackingOption.value === 'ArrivalMultipleOr') {
            // keep the either/or flags current as the light level is typed
            var bothMissing = !service.endTrackingGeofence.value && isBlankValue(field.value);
            service.endTrackingGeofence.errors.thisOrLight = bothMissing;
            field.errors.thisOrGeofence = bothMissing;
        }
        if (isBlankValue(field.value)) {
            field.errors.isBlank = service.endTrackingOption.value !== 'ArrivalMultipleOr';
            return;
        }
        validateRange(field);
    }

    function isBlankValue(value) {
        return value === null || value === undefined;
    }

    function validateArrivalLightLevelThrottleHours() {
        validateOptionalRange(service.arrivalLightLevelThrottleHours);
    }

    function validateCompletionDelay() {
        validateOptionalRange(service.completionDelay);
    }

    function validateOptionalRange(field) {
        field.errors.belowMin = false;
        field.errors.aboveMax = false;
        if (!isMultipleConditionEndOption(service.endTrackingOption.value) || isBlankValue(field.value)) {
            return;
        }
        validateRange(field);
    }

    function validateRange(field) {
        field.errors.belowMin = field.value < field.min;
        field.errors.aboveMax = field.value > field.max;
    }

    function validateTrackingStrategies() {
        validateBeginTrackingGeofence();
        validateEndTrackingGeofence();
        validateArrivalLightLevel();
        validateArrivalLightLevelThrottleHours();
        validateCompletionDelay();
    }

    function hasTrackingStrategyError() {
        return service.beginTrackingGeofence.hasError() || service.endTrackingGeofence.hasError() ||
            service.arrivalLightLevel.hasError() || service.arrivalLightLevelThrottleHours.hasError() || service.completionDelay.hasError();
    }

    function validateName() {
        service.name.isPristine = false;
        service.name.errors.isBlank = !service.name.value || service.name.value === '';
        service.name.errors.isDuplicate = false;
    }

    function validateDuration() {
        service.duration.isPristine = false;
        service.duration.errors.isOutOfRange = service.duration.value !== null ? service.duration.value < MIN_DURATION || service.duration.value > MAX_DURATION : false;
    }

    function validateStops() {
        //validateStop(service.stops.origin);
        _.forEach(service.stops.other, function (stop) {
            validateStop(stop);
        });
        //validateStop(service.stops.destination);
    }

    function validateStop(stop) {
        if (stop.type === 'address') {
            stop.address.validate();
            stop.locationSearch.validate();
        }

        if (stop.type === 'geofence') {
            stop.geofence.validate();
        }
    }

    function validateSubscribers() {
        service.shipmentEmails.isPristine = false;
        service.shipmentEmails.isValid = true;
        service.shipmentEmails.errors.invalidEmails = [];

        if (service.shipmentEmails.value === null || service.shipmentEmails.value.trim() === '') {
            return;
        }

        var emails = service.shipmentEmails.value.replace(/\s/g, '').split(";").join(",").split(',');
        _.forEach(emails, function (email) {
            if (email !== null && email.trim() !== '') {
                var isEmail = emailValidator.test(email.trim());
                if (!isEmail) {
                    service.shipmentEmails.errors.invalidEmails.push(email.trim());
                }
            }
        });
    }
}
